<div *ngIf="levelList.length>0 && !loading">
<h2 class="text-center"> Levels</h2>
<app-list-level-template  [levelList]="levelList"></app-list-level-template>
</div>
<div *ngIf="levelList.length==0 && !loading" class="text-center">
  No levels found
</div>
<app-spinner *ngIf="loading"></app-spinner>

